export default "__VITE_ASSET__CeHjiHJS__"